var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { staticClass: "fullSize" },
    [
      _vm.error
        ? _c("default-page", {
            attrs: { errorMessage: _vm.errorMessage, buttonText: "Reload" },
            on: { "button-clicked": _vm.reloadPage },
          })
        : _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _vm.isNotDesktop
                ? _c("div", { staticClass: "navDraw-helper" })
                : _vm._e(),
              _c(
                "v-flex",
                { staticClass: "fullSize" },
                [
                  _vm.loading ||
                  _vm.vuexIsLoading ||
                  _vm.loadingConfigurations ||
                  !_vm.settingsLoaded
                    ? _c("loading-page")
                    : _vm.pageIsEmpty || _vm.pageWasEmpty
                    ? _c(
                        "div",
                        [
                          _c("default-page", {
                            attrs: {
                              imageUrl: "/img/dynamic-src-images/analytics.svg",
                              title: _vm.$options.name,
                              text: "It seems that you don't have any analytics instances running. Click Get Started below to add Applications",
                              buttonText: "Get Started",
                            },
                            on: {
                              "button-clicked": function ($event) {
                                return _vm.$router.push({
                                  path: "/applications",
                                  query: {
                                    add: true,
                                  },
                                })
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "v-tabs",
                        {
                          attrs: {
                            slot: "extension",
                            id: "vTabsId",
                            height: "50",
                            "background-color": _vm.$vuetify.theme.dark
                              ? "#3d3d3d"
                              : "#fff",
                            centered: "",
                            value: _vm.tabs,
                            "hide-slider": "",
                            "center-active": "",
                            "show-arrows": "",
                            "slider-size": 3,
                          },
                          slot: "extension",
                        },
                        [
                          _vm.$vuetify.breakpoint.xsOnly &&
                          _vm.fetchAnalyticInstancesFiltered.length &&
                          _vm.grids != null
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        disabled:
                                          (_vm.analyticInstances.length == 1 &&
                                            !_vm.analyticInstances[0]
                                              .mergedInstance) ||
                                          (_vm.analyticInstances.length == 3 &&
                                            _vm.mergedInstances.length > 0 &&
                                            !_vm.currentTabItem.mergedInstance),
                                        "offset-y": "",
                                        "close-on-content-click": false,
                                        "open-on-click": "",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "v-tab",
                                                  _vm._g(
                                                    {
                                                      staticClass:
                                                        "vTabClassMobile char-lim-tabs",
                                                      staticStyle: {
                                                        height: "50px",
                                                      },
                                                      attrs: {
                                                        "active-class":
                                                          "selectedTab",
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _vm.currentTabItem
                                                      .mergedInstance
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "my-auto",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm
                                                                    .currentTabItem
                                                                    .name
                                                                ) +
                                                                " (" +
                                                                _vm._s(
                                                                  _vm
                                                                    .currentTabItem
                                                                    .subinstances
                                                                    .length
                                                                ) +
                                                                ") "
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "my-auto",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .currentTabItem
                                                                  .name
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3222350000
                                      ),
                                      model: {
                                        value: _vm.currentTabItem.mobileModel,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.currentTabItem,
                                            "mobileModel",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "currentTabItem.mobileModel",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "accent",
                                          attrs: { width: "100%" },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "mx-0",
                                              attrs: { justify: "center" },
                                            },
                                            [
                                              !_vm.currentTabItem
                                                .showMergeTabMobile &&
                                              !_vm.currentTabItem.mergedInstance
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "text-center mb-0",
                                                      staticStyle: {
                                                        "font-size": "15px",
                                                      },
                                                      attrs: {
                                                        width: "100%",
                                                        text: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openMergePanel(
                                                            _vm.currentTabItem
                                                              .id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Merge ")]
                                                  )
                                                : _vm.currentTabItem
                                                    .mobileModel &&
                                                  _vm.currentTabItem
                                                    .mergedInstance
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                    },
                                                    [
                                                      _vm._l(
                                                        _vm
                                                          .getCurrentUpdatedItem
                                                          .subinstances,
                                                        function (item) {
                                                          return _c(
                                                            "v-row",
                                                            {
                                                              key: item.id,
                                                              staticClass:
                                                                "mx-0",
                                                              staticStyle: {
                                                                "border-bottom":
                                                                  "1px solid rgb(255, 255, 255, 0.2)",
                                                              },
                                                              attrs: {
                                                                justify:
                                                                  "space-between",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "ml-4 my-1",
                                                                  staticStyle: {
                                                                    "font-size":
                                                                      "12px",
                                                                  },
                                                                  attrs: {
                                                                    dense: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item.name
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  staticClass:
                                                                    "mr-2 my-auto",
                                                                  attrs: {
                                                                    icon: "",
                                                                    "x-small":
                                                                      "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.updateMergedInstance(
                                                                          _vm
                                                                            .MERGED_ACTIONS
                                                                            .REMOVE,
                                                                          item.id,
                                                                          _vm
                                                                            .currentTabItem
                                                                            .id
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        small:
                                                                          "",
                                                                        color:
                                                                          "red",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "fas fa-times"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "text-center mb-0",
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            disabled:
                                                              !_vm
                                                                .getCurrentUpdatedItem
                                                                .availableInstances
                                                                .length,
                                                            small: "",
                                                            text: "",
                                                            id: `addSubinstance${_vm.currentTabItem.id}`,
                                                            color: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.toggleAddMoreInstancesTab(
                                                                _vm
                                                                  .currentTabItem
                                                                  .id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "mr-1",
                                                              attrs: {
                                                                "x-small": "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "fas fa-plus"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" Add More "),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-menu",
                                                        {
                                                          attrs: {
                                                            activator: `#addSubinstance${_vm.currentTabItem.id}`,
                                                            "offset-y": "",
                                                            "close-on-click": true,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.mergeTabs[
                                                                _vm
                                                                  .currentTabItem
                                                                  .id
                                                              ]
                                                                .addInstancesSelector,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.mergeTabs[
                                                                  _vm
                                                                    .currentTabItem
                                                                    .id
                                                                ],
                                                                "addInstancesSelector",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "\n                      mergeTabs[currentTabItem.id].addInstancesSelector\n                    ",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list",
                                                            {
                                                              staticClass:
                                                                "accent",
                                                            },
                                                            _vm._l(
                                                              _vm.currentTabItem
                                                                .availableInstances,
                                                              function (item) {
                                                                return _c(
                                                                  "v-list-item",
                                                                  {
                                                                    key: item.id,
                                                                    staticStyle:
                                                                      {
                                                                        "min-height":
                                                                          "28px",
                                                                      },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.updateMergedInstance(
                                                                            _vm
                                                                              .MERGED_ACTIONS
                                                                              .ADD,
                                                                            item.id,
                                                                            _vm
                                                                              .currentTabItem
                                                                              .id,
                                                                            item.name
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "mb-0",
                                                                        staticStyle:
                                                                          {
                                                                            "font-size":
                                                                              "12px",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              item.name
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "text-center mb-0 red--text",
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            small: "",
                                                            text: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.destroyMergedInstance(
                                                                _vm
                                                                  .currentTabItem
                                                                  .id,
                                                                true,
                                                                false,
                                                                true
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "destroy with ID" +
                                                              _vm._s(
                                                                _vm
                                                                  .currentTabItem
                                                                  .id
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm.currentTabItem
                                                        .hideSeperated
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "badly-visible-text my-0 mx-1 text-center",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "12px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Subinstances are hidden "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _vm.currentTabItem.showMergeTabMobile
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-center my-2",
                                                      staticStyle: {
                                                        "font-size": "12px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.currentTabItem
                                                              .name
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    {
                                                      staticClass: "mx-0",
                                                      attrs: {
                                                        justify: "center",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "8px",
                                                            transform:
                                                              "rotate(90deg)",
                                                            height: "16px",
                                                          },
                                                          attrs: {
                                                            "x-small": "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "icon-more-23x13 "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list",
                                                    {
                                                      staticStyle: {
                                                        "overflow-y": "auto",
                                                      },
                                                      attrs: {
                                                        width: "100%",
                                                        "max-height": "120px",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.mergeTargets,
                                                      function (mergable) {
                                                        return _c(
                                                          "v-list-item",
                                                          {
                                                            key: mergable.id,
                                                            staticClass:
                                                              "px-1 clickable merge-select-item",
                                                            staticStyle: {
                                                              "min-height":
                                                                "32px",
                                                              height: "32px",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.selectMergableInstance(
                                                                  mergable
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  small: "",
                                                                  color:
                                                                    "primary",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      mergable.checked
                                                                        ? "far fa-dot-circle"
                                                                        : "radio_button_unchecked"
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "primary--text mb-0 pl-2",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "14px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      mergable.name
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        "content-class":
                                                          "tooltip-top-mg",
                                                        bottom: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    on
                                                                  ),
                                                                  _vm._l(
                                                                    _vm.getInCompatibleInstances(
                                                                      _vm
                                                                        .currentTabItem
                                                                        .id
                                                                    ),
                                                                    function (
                                                                      incomp
                                                                    ) {
                                                                      return _c(
                                                                        "v-list-item",
                                                                        {
                                                                          key: incomp.id,
                                                                          staticClass:
                                                                            "px-1 incomp-merge-select-item",
                                                                          staticStyle:
                                                                            {
                                                                              "min-height":
                                                                                "32px",
                                                                              height:
                                                                                "32px",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  small:
                                                                                    "",
                                                                                  color:
                                                                                    "grey",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    incomp.checked
                                                                                      ? "far fa-dot-circle"
                                                                                      : "radio_button_unchecked"
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "grey--text mb-0 pl-2",
                                                                              staticStyle:
                                                                                {
                                                                                  "font-size":
                                                                                    "14px",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    incomp.name
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    }
                                                                  ),
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        2721482815
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "Can't merge to these instances due to"
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "incompatibility of summary table grouping"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm.noInstancesSelected &&
                                                  _vm.mergePanelInitialInteraction
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "red--text mt-1 ml-1 mb-0",
                                                          staticStyle: {
                                                            "font-size": "12px",
                                                            "letter-spacing":
                                                              "0.01em",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Select at least one instance "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        right: "",
                                                        "content-class":
                                                          "tooltip-top-mg",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    attrs: {
                                                                      "v-on":
                                                                        _vm.isNotDesktop
                                                                          ? 0
                                                                          : on,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-checkbox",
                                                                      {
                                                                        staticClass:
                                                                          "extra-small-checkbox mt-0 pt-0",
                                                                        attrs: {
                                                                          dense:
                                                                            "",
                                                                          "x-small":
                                                                            "",
                                                                          "hide-details":
                                                                            "",
                                                                          label:
                                                                            "Hide subinstances",
                                                                          "on-icon":
                                                                            "fas fa-check-square",
                                                                          "off-icon":
                                                                            "far fa-check-square",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.hideSeperatedInstances,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.hideSeperatedInstances =
                                                                                $$v
                                                                            },
                                                                          expression:
                                                                            "hideSeperatedInstances",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        3848948973
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "Hide seperated instances"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c("v-checkbox", {
                                                    staticClass:
                                                      "extra-small-checkbox mt-0 pt-0",
                                                    attrs: {
                                                      dense: "",
                                                      "x-small": "",
                                                      "hide-details": "",
                                                      label:
                                                        "Auto-generated name",
                                                      "on-icon":
                                                        "fas fa-check-square",
                                                      "off-icon":
                                                        "far fa-check-square",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.autoGenerateName,
                                                      callback: function ($$v) {
                                                        _vm.autoGenerateName =
                                                          $$v
                                                      },
                                                      expression:
                                                        "autoGenerateName",
                                                    },
                                                  }),
                                                  !_vm.autoGenerateName
                                                    ? _c("v-text-field", {
                                                        staticClass:
                                                          "mini-text-field mt-1 ml-1",
                                                        staticStyle: {
                                                          "max-width": "150px",
                                                          height: "30px",
                                                        },
                                                        attrs: {
                                                          label: "Custom Name",
                                                          outlined: "",
                                                          dense: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.customMergeName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.customMergeName =
                                                              $$v
                                                          },
                                                          expression:
                                                            "customMergeName",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _c(
                                                    "v-row",
                                                    {
                                                      staticClass: "mx-0",
                                                      attrs: {
                                                        justify: "center",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "text-center mt-1",
                                                          staticStyle: {
                                                            "font-size": "16px",
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            disabled:
                                                              _vm.noInstancesSelected,
                                                            text: "",
                                                            small: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.mergeInstances(
                                                                _vm.currentTabItem
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("Ok ")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "v-row",
                                {
                                  key: _vm.vTabRenderKey,
                                  attrs: { justify: "center" },
                                },
                                _vm._l(
                                  _vm.analyticInstances,
                                  function (instance, index) {
                                    return _c(
                                      "v-menu",
                                      {
                                        key: instance.id,
                                        attrs: {
                                          disabled: _vm.disableTabsMenu(
                                            instance.id,
                                            instance.mergedInstance
                                          ),
                                          "offset-y": "",
                                          "close-on-content-click": false,
                                          "open-on-click": _vm.isNotDesktop,
                                          "open-on-hover":
                                            _vm.mergeTabs[instance.id]
                                              .openOnHover && !_vm.isNotDesktop,
                                          "content-class": "m-t-n1",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    "v-tab",
                                                    _vm._g(
                                                      {
                                                        staticClass:
                                                          "vTabClass",
                                                        staticStyle: {
                                                          height: "50px",
                                                        },
                                                        attrs: {
                                                          transition:
                                                            "slide-x-transition",
                                                          "active-class":
                                                            "selectedTab",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.addItem(
                                                              instance,
                                                              index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      instance.mergedInstance
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "my-auto",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    instance.name
                                                                  ) +
                                                                  " (" +
                                                                  _vm._s(
                                                                    instance
                                                                      .subinstances
                                                                      .length
                                                                  ) +
                                                                  ") "
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "my-auto",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  instance.name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value:
                                            _vm.mergeTabs[instance.id].model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.mergeTabs[instance.id],
                                              "model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "mergeTabs[instance.id].model",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-card",
                                          {
                                            staticClass: "accent",
                                            attrs: { width: "100%" },
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "mx-0",
                                                attrs: { justify: "center" },
                                              },
                                              [
                                                !_vm.mergeTabs[instance.id]
                                                  .showMergeTab &&
                                                !instance.mergedInstance
                                                  ? _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "text-center mb-0",
                                                        staticStyle: {
                                                          "font-size": "15px",
                                                        },
                                                        attrs: {
                                                          width: "100%",
                                                          text: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openMergePanel(
                                                              instance.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("Merge ")]
                                                    )
                                                  : _vm.mergeTabs[instance.id]
                                                      .model &&
                                                    instance.mergedInstance
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                      },
                                                      [
                                                        _vm._l(
                                                          instance.subinstances,
                                                          function (item) {
                                                            return _c(
                                                              "v-row",
                                                              {
                                                                key: item.id,
                                                                staticClass:
                                                                  "mx-0",
                                                                staticStyle: {
                                                                  "border-bottom":
                                                                    "1px solid rgb(255, 255, 255, 0.2)",
                                                                },
                                                                attrs: {
                                                                  justify:
                                                                    "space-between",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "ml-4 my-1",
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "12px",
                                                                      },
                                                                    attrs: {
                                                                      dense: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          item.name
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    staticClass:
                                                                      "mr-2 my-auto",
                                                                    attrs: {
                                                                      icon: "",
                                                                      "x-small":
                                                                        "",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.updateMergedInstance(
                                                                            _vm
                                                                              .MERGED_ACTIONS
                                                                              .REMOVE,
                                                                            item.id,
                                                                            instance.id
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            "",
                                                                          color:
                                                                            "red",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "fas fa-times"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        _c(
                                                          "v-row",
                                                          {
                                                            staticClass: "mx-0",
                                                          },
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "text-center mb-0",
                                                                staticStyle: {
                                                                  width: "100%",
                                                                },
                                                                attrs: {
                                                                  disabled:
                                                                    !instance
                                                                      .availableInstances
                                                                      .length,
                                                                  small: "",
                                                                  text: "",
                                                                  id: `addSubinstance${instance.id}`,
                                                                  color:
                                                                    "primary",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.toggleAddMoreInstancesTab(
                                                                        instance.id
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mr-1",
                                                                    attrs: {
                                                                      "x-small":
                                                                        "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "fas fa-plus"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  " Add More "
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-menu",
                                                              {
                                                                attrs: {
                                                                  activator: `#addSubinstance${instance.id}`,
                                                                  "offset-y":
                                                                    "",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .mergeTabs[
                                                                      instance
                                                                        .id
                                                                    ]
                                                                      .addInstancesSelector,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .mergeTabs[
                                                                          instance
                                                                            .id
                                                                        ],
                                                                        "addInstancesSelector",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "mergeTabs[instance.id].addInstancesSelector",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list",
                                                                  {
                                                                    staticClass:
                                                                      "accent",
                                                                  },
                                                                  _vm._l(
                                                                    instance.availableInstances,
                                                                    function (
                                                                      item
                                                                    ) {
                                                                      return _c(
                                                                        "v-list-item",
                                                                        {
                                                                          key: item.id,
                                                                          staticStyle:
                                                                            {
                                                                              "min-height":
                                                                                "28px",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.updateMergedInstance(
                                                                                  _vm
                                                                                    .MERGED_ACTIONS
                                                                                    .ADD,
                                                                                  item.id,
                                                                                  instance.id,
                                                                                  item.name
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "mb-0",
                                                                              staticStyle:
                                                                                {
                                                                                  "font-size":
                                                                                    "12px",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    item.name
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "text-center mb-0 red--text",
                                                                staticStyle: {
                                                                  width: "100%",
                                                                },
                                                                attrs: {
                                                                  small: "",
                                                                  text: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.destroyMergedInstance(
                                                                        instance.id,
                                                                        true,
                                                                        false,
                                                                        true
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "destroy "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        instance.hideSeperated
                                                          ? _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "badly-visible-text my-0 mx-1 text-center",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Subinstances are hidden "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                            _vm.mergeTabs[instance.id]
                                              .showMergeTab
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-center mt-2 mb-1",
                                                        staticStyle: {
                                                          "font-size": "12px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              instance.name
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-row",
                                                      {
                                                        staticClass: "mx-0",
                                                        attrs: {
                                                          justify: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "mb-1",
                                                            staticStyle: {
                                                              "font-size":
                                                                "8px",
                                                              transform:
                                                                "rotate(90deg)",
                                                              height: "16px",
                                                            },
                                                            attrs: {
                                                              "x-small": "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "icon-more-23x13 "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-row",
                                                      { staticClass: "mx-0" },
                                                      [
                                                        _c(
                                                          "v-list",
                                                          {
                                                            staticStyle: {
                                                              "overflow-y":
                                                                "auto",
                                                            },
                                                            attrs: {
                                                              width: "100%",
                                                              "max-height":
                                                                "120px",
                                                            },
                                                          },
                                                          [
                                                            _vm._l(
                                                              _vm.mergeTargets,
                                                              function (
                                                                mergable
                                                              ) {
                                                                return _c(
                                                                  "v-list-item",
                                                                  {
                                                                    key: mergable.id,
                                                                    staticClass:
                                                                      "px-1 clickable merge-select-item",
                                                                    staticStyle:
                                                                      {
                                                                        "min-height":
                                                                          "32px",
                                                                        height:
                                                                          "32px",
                                                                      },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.selectMergableInstance(
                                                                            mergable
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            "",
                                                                          color:
                                                                            "primary",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              mergable.checked
                                                                                ? "far fa-dot-circle"
                                                                                : "radio_button_unchecked"
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "primary--text mb-0 pl-2",
                                                                        staticStyle:
                                                                          {
                                                                            "font-size":
                                                                              "14px",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              mergable.name
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            _c(
                                                              "v-tooltip",
                                                              {
                                                                attrs: {
                                                                  "content-class":
                                                                    "tooltip-top-mg",
                                                                  bottom: "",
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "activator",
                                                                        fn: function ({
                                                                          on,
                                                                        }) {
                                                                          return [
                                                                            _c(
                                                                              "div",
                                                                              _vm._g(
                                                                                {},
                                                                                on
                                                                              ),
                                                                              _vm._l(
                                                                                _vm.getInCompatibleInstances(
                                                                                  instance.id
                                                                                ),
                                                                                function (
                                                                                  incomp
                                                                                ) {
                                                                                  return _c(
                                                                                    "v-list-item",
                                                                                    {
                                                                                      key: incomp.id,
                                                                                      staticClass:
                                                                                        "px-1 incomp-merge-select-item",
                                                                                      staticStyle:
                                                                                        {
                                                                                          "min-height":
                                                                                            "32px",
                                                                                          height:
                                                                                            "32px",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "v-icon",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              small:
                                                                                                "",
                                                                                              color:
                                                                                                "grey",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " " +
                                                                                              _vm._s(
                                                                                                incomp.checked
                                                                                                  ? "far fa-dot-circle"
                                                                                                  : "radio_button_unchecked"
                                                                                              ) +
                                                                                              " "
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "p",
                                                                                        {
                                                                                          staticClass:
                                                                                            "grey--text mb-0 pl-2",
                                                                                          staticStyle:
                                                                                            {
                                                                                              "font-size":
                                                                                                "14px",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " " +
                                                                                              _vm._s(
                                                                                                incomp.name
                                                                                              ) +
                                                                                              " "
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                }
                                                                              ),
                                                                              1
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    "Can't merge to these instances due to"
                                                                  ),
                                                                  _c("br"),
                                                                  _vm._v(
                                                                    "incompatibility of summary table grouping"
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm.noInstancesSelected &&
                                                    _vm.mergePanelInitialInteraction
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "red--text mt-1 ml-1 mb-0",
                                                            staticStyle: {
                                                              "font-size":
                                                                "12px",
                                                              "letter-spacing":
                                                                "0.01em",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Select at least one instance "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "v-tooltip",
                                                      {
                                                        attrs: {
                                                          right: "",
                                                          "content-class":
                                                            "tooltip-top-mg",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      attrs: {
                                                                        "v-on":
                                                                          _vm.isNotDesktop
                                                                            ? 0
                                                                            : on,
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-checkbox",
                                                                        {
                                                                          staticClass:
                                                                            "extra-small-checkbox mt-0 pt-0",
                                                                          attrs:
                                                                            {
                                                                              dense:
                                                                                "",
                                                                              "x-small":
                                                                                "",
                                                                              "hide-details":
                                                                                "",
                                                                              label:
                                                                                "Hide subinstances",
                                                                              "on-icon":
                                                                                "fas fa-check-square",
                                                                              "off-icon":
                                                                                "far fa-check-square",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm.hideSeperatedInstances,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.hideSeperatedInstances =
                                                                                    $$v
                                                                                },
                                                                              expression:
                                                                                "hideSeperatedInstances",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "Hide seperated instances"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c("v-checkbox", {
                                                      staticClass:
                                                        "extra-small-checkbox mt-0 pt-0",
                                                      attrs: {
                                                        dense: "",
                                                        "x-small": "",
                                                        "hide-details": "",
                                                        label:
                                                          "Auto-generated name",
                                                        "on-icon":
                                                          "fas fa-check-square",
                                                        "off-icon":
                                                          "far fa-check-square",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.autoGenerateName,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.autoGenerateName =
                                                            $$v
                                                        },
                                                        expression:
                                                          "autoGenerateName",
                                                      },
                                                    }),
                                                    !_vm.autoGenerateName
                                                      ? _c("v-text-field", {
                                                          staticClass:
                                                            "mini-text-field mt-1 ml-1",
                                                          staticStyle: {
                                                            "max-width":
                                                              "150px",
                                                            height: "30px",
                                                          },
                                                          attrs: {
                                                            label:
                                                              "Custom Name",
                                                            outlined: "",
                                                            dense: "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.customMergeName,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.customMergeName =
                                                                $$v
                                                            },
                                                            expression:
                                                              "customMergeName",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _c(
                                                      "v-row",
                                                      {
                                                        staticClass: "mx-0",
                                                        attrs: {
                                                          justify: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "text-center mt-1",
                                                            staticStyle: {
                                                              "font-size":
                                                                "16px",
                                                              width: "100%",
                                                            },
                                                            attrs: {
                                                              disabled:
                                                                _vm.noInstancesSelected,
                                                              text: "",
                                                              small: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.mergeInstances(
                                                                  instance
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("Ok ")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                          _vm.currentTabItem != null &&
                          _vm.currentTabItem.id != undefined
                            ? _c(
                                "v-tabs-items",
                                {
                                  staticClass: "accent",
                                  style: `overflow: hidden auto;height: ${
                                    _vm.windowSizeY - 105
                                  }px;`,
                                  model: {
                                    value: _vm.currentTabItem.id,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.currentTabItem, "id", $$v)
                                    },
                                    expression: "currentTabItem.id",
                                  },
                                },
                                _vm._l(
                                  _vm.analyticInstances,
                                  function (instance, index) {
                                    return _c(
                                      "v-tab-item",
                                      {
                                        key: instance.id,
                                        attrs: {
                                          value: instance.id,
                                          disabled: true,
                                        },
                                      },
                                      [
                                        _vm.isFrozenOrNotRunningMessage
                                          .message ||
                                        (_vm.isFrozenOrNotRunningMessage
                                          .instances &&
                                          _vm.isFrozenOrNotRunningMessage
                                            .instances.length)
                                          ? _c(
                                              "div",
                                              [
                                                _vm.isFrozenOrNotRunningMessage
                                                  .message
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "app-issue-info",
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "14px",
                                                              "margin-bottom":
                                                                "4px",
                                                            },
                                                            attrs: {
                                                              color: "red",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "fas fa-exclamation-triangle "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm
                                                                .isFrozenOrNotRunningMessage
                                                                .message
                                                            ) +
                                                            " "
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm
                                                      .isFrozenOrNotRunningMessage
                                                      .configsChanged
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "app-issue-info",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Configurations were changed, reloading this page.. "
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "mx-1 app-issue-info simple-slow-opacityAN",
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "14px",
                                                                  "margin-bottom":
                                                                    "4px",
                                                                },
                                                                attrs: {
                                                                  color: "red",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "fas fa-exclamation-triangle "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              " Issues were found "
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-menu",
                                                          {
                                                            attrs: {
                                                              "offset-y": "",
                                                              "close-on-content-click": false,
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "v-btn",
                                                                        _vm._g(
                                                                          {
                                                                            staticClass:
                                                                              "px-1 ml-1",
                                                                            attrs:
                                                                              {
                                                                                "x-small":
                                                                                  "",
                                                                                text: "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                () => {},
                                                                            },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "red--text mb-0",
                                                                              staticStyle:
                                                                                {
                                                                                  "font-size":
                                                                                    "12px",
                                                                                  "margin-top":
                                                                                    "2px",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " See more "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c(
                                                              "v-card",
                                                              {
                                                                staticClass:
                                                                  "accent pa-1",
                                                              },
                                                              _vm._l(
                                                                _vm
                                                                  .isFrozenOrNotRunningMessage
                                                                  .instances,
                                                                function (
                                                                  issue
                                                                ) {
                                                                  return _c(
                                                                    "tr",
                                                                    {
                                                                      key: issue.id,
                                                                      staticClass:
                                                                        "dataTableRow",
                                                                      staticStyle:
                                                                        {
                                                                          "max-width":
                                                                            "300px",
                                                                          height:
                                                                            "28px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c("td", [
                                                                        _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "my-1 mx-2",
                                                                            staticStyle:
                                                                              {
                                                                                "font-size":
                                                                                  "12px",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  issue.name
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]),
                                                                      _c(
                                                                        "td",
                                                                        _vm._l(
                                                                          issue.info,
                                                                          function (
                                                                            infoItem
                                                                          ) {
                                                                            return _c(
                                                                              "div",
                                                                              {
                                                                                key: infoItem.text,
                                                                                staticClass:
                                                                                  "mx-2",
                                                                              },
                                                                              [
                                                                                infoItem.type ==
                                                                                _vm
                                                                                  .INSTANCE_ISSUES
                                                                                  .FROZEN
                                                                                  ? _c(
                                                                                      "v-icon",
                                                                                      {
                                                                                        staticStyle:
                                                                                          {
                                                                                            "margin-right":
                                                                                              "2px",
                                                                                          },
                                                                                        attrs:
                                                                                          {
                                                                                            "x-small":
                                                                                              "",
                                                                                            color:
                                                                                              "primary",
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          " fas fa-sync-alt "
                                                                                        ),
                                                                                      ]
                                                                                    )
                                                                                  : infoItem.type ==
                                                                                    _vm
                                                                                      .INSTANCE_ISSUES
                                                                                      .NOT_RUNNING
                                                                                  ? _c(
                                                                                      "v-icon",
                                                                                      {
                                                                                        staticStyle:
                                                                                          {
                                                                                            "font-size":
                                                                                              "13px",
                                                                                            "margin-right":
                                                                                              "2px",
                                                                                          },
                                                                                        attrs:
                                                                                          {
                                                                                            "x-small":
                                                                                              "",
                                                                                            color:
                                                                                              "red",
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          " far fa-play-circle "
                                                                                        ),
                                                                                      ]
                                                                                    )
                                                                                  : _c(
                                                                                      "v-icon",
                                                                                      {
                                                                                        staticStyle:
                                                                                          {
                                                                                            "font-size":
                                                                                              "13px",
                                                                                            "margin-right":
                                                                                              "2px",
                                                                                          },
                                                                                        attrs:
                                                                                          {
                                                                                            "x-small":
                                                                                              "",
                                                                                            color:
                                                                                              "red",
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          " fas fa-wifi "
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "my-1 ml-1",
                                                                                    staticStyle:
                                                                                      {
                                                                                        "font-size":
                                                                                          "12px",
                                                                                        display:
                                                                                          "inline",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      " " +
                                                                                        _vm._s(
                                                                                          infoItem.text
                                                                                        ) +
                                                                                        " "
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            )
                                                                          }
                                                                        ),
                                                                        0
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "grid-layout",
                                          {
                                            class: _vm.$vuetify.theme.dark
                                              ? "darkTheme"
                                              : "lightTheme",
                                            attrs: {
                                              layout: _vm.getLayout(
                                                instance.id
                                              ),
                                              "col-num": 18,
                                              "row-num": 2,
                                              "row-height": 60,
                                              "min-h": 6,
                                              "min-w": 6,
                                              "is-draggable":
                                                _vm.isDraggableDesktop ||
                                                _vm.isDraggable,
                                              "is-resizable": true,
                                              "is-mirrored": false,
                                              "use-css-transforms": true,
                                            },
                                          },
                                          _vm._l(
                                            _vm.getLayout(instance.id),
                                            function (item) {
                                              return _c(
                                                "div",
                                                { key: item.i },
                                                [
                                                  _c(
                                                    "transition",
                                                    { attrs: { name: "fade" } },
                                                    [
                                                      _c(
                                                        "grid-item",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value: !(
                                                                item.tableName ==
                                                                  "exposure" &&
                                                                !_vm.showingExposureTable
                                                              ),
                                                              expression:
                                                                "\n                      !(item.tableName == 'exposure' && !showingExposureTable)\n                    ",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "mt-3 draggable simple-slow-opacityAN",
                                                          attrs: {
                                                            dragAllowFrom:
                                                              _vm.$vuetify
                                                                .breakpoint
                                                                .smAndDown ||
                                                              _vm.isNotDesktop
                                                                ? ".dragFromHere"
                                                                : ".ag-body-viewport",
                                                            x: item.x,
                                                            y: item.y,
                                                            w: item.w,
                                                            h: item.h,
                                                            i: item.i,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-row",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    _vm.isDraggable,
                                                                  expression:
                                                                    "isDraggable",
                                                                },
                                                              ],
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "py-0",
                                                                  attrs: {
                                                                    cols: "3",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-avatar",
                                                                    {
                                                                      staticClass:
                                                                        "drag_thumb",
                                                                      attrs: {
                                                                        size: "41",
                                                                        color:
                                                                          "#1C6E59",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          staticClass:
                                                                            "dragFromHere",
                                                                          attrs:
                                                                            {
                                                                              color:
                                                                                "white",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "icon-4drag "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c("ag-grid-vue", {
                                                            key: _vm.getKey(
                                                              item.i,
                                                              index
                                                            ),
                                                            staticClass:
                                                              "mt-1 queryBuilder--dark",
                                                            class: _vm.$vuetify
                                                              .theme.dark
                                                              ? "ag-theme-custom-balham-dark-vue"
                                                              : "ag-theme-custom-balham-vue",
                                                            staticStyle: {
                                                              height: "100%",
                                                              width: "100%",
                                                            },
                                                            attrs: {
                                                              id: _vm.getTableDragVModel
                                                                ? "dragable-grid"
                                                                : "not-dragable-grid",
                                                              pinnedBottomRowData:
                                                                item.i == "0"
                                                                  ? _vm.getPinnedBottomRowData
                                                                  : null,
                                                              gridOptions:
                                                                _vm.getGridOptions(
                                                                  item.i,
                                                                  instance.id
                                                                ),
                                                              columnDefs:
                                                                _vm.getColumnsDefs(
                                                                  item.i,
                                                                  instance
                                                                ),
                                                              immutableData: true,
                                                              statusBar:
                                                                _vm.statusBar,
                                                              animateRows: true,
                                                              enableRangeSelection: true,
                                                              rowGroupPanelShow:
                                                                _vm.rowGroupPanelShow,
                                                              pivotPanelShow:
                                                                _vm.pivotPanelShow,
                                                              suppressAggFuncInHeader: true,
                                                              getRowNodeId: (
                                                                data
                                                              ) =>
                                                                _vm.getRowNodeId(
                                                                  data,
                                                                  instance
                                                                ),
                                                              defaultColDef:
                                                                _vm.defaultColDef,
                                                              autoGroupColumnDef:
                                                                _vm.autoGroupColumnDef,
                                                              getRowStyle:
                                                                _vm.getRowStyle,
                                                              groupRowAggNodes:
                                                                _vm.getGroupRowAggNodes(
                                                                  item.i
                                                                ),
                                                            },
                                                            on: {
                                                              dragStopped:
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.tableStateChange(
                                                                    $event,
                                                                    item.i,
                                                                    "dragStopped",
                                                                    item.tableName
                                                                  )
                                                                },
                                                              columnRowGroupChanged:
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.tableStateChange(
                                                                    $event,
                                                                    item.i,
                                                                    "columnRowGroupChanged",
                                                                    item.tableName
                                                                  )
                                                                },
                                                              "row-group-opened":
                                                                _vm.rowExpanded,
                                                              "grid-ready":
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.onGridReady(
                                                                    item.i
                                                                  )
                                                                },
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                  !_vm.loading && !_vm.pageIsEmpty && !_vm.pageWasEmpty
                    ? _c(
                        "v-menu",
                        {
                          staticStyle: { right: "10px" },
                          attrs: {
                            "content-class": "normal-menu w-220",
                            transition: "slide-y-transition",
                            bottom: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass:
                                            "white--text more-btn-analytics",
                                          attrs: { icon: "" },
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "icon-more-21x21",
                                            staticStyle: {
                                              "font-size": "28px",
                                              "margin-right": "2px",
                                              "letter-spacing": "0 !important",
                                            },
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "path1 letterSpacing0",
                                            }),
                                            _c("span", {
                                              staticClass:
                                                "path2 letterSpacing0",
                                            }),
                                            _c("span", {
                                              staticClass:
                                                "path3 letterSpacing0",
                                            }),
                                            _c("span", {
                                              staticClass:
                                                "path4 letterSpacing0",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2402089114
                          ),
                        },
                        [
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            _vm._l(_vm.actionItems, function (item, i) {
                              return _c(
                                "v-list-item",
                                {
                                  key: i,
                                  on: {
                                    click: function ($event) {
                                      return item.action()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-action",
                                    { staticClass: "mr-5" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          class: item.clicked()
                                            ? "primary--text"
                                            : "supplementary-class",
                                          staticStyle: { "font-size": "20px" },
                                        },
                                        [_vm._v(_vm._s(item.icon) + " ")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        {
                                          class: item.clicked()
                                            ? "primary--text"
                                            : "supplementary-class",
                                          staticStyle: { "font-size": "15px" },
                                        },
                                        [_vm._v(_vm._s(item.text) + " ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _vm.$vuetify.breakpoint.xsOnly
                            ? _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "pl-4 mt-1 font-weight-bold list-title-background",
                                  staticStyle: {
                                    "border-radius": "4px 4px 0 0",
                                    "font-size": "15px",
                                    "letter-spacing": "0.04rem",
                                  },
                                },
                                [_vm._v("Instances ")]
                              )
                            : _vm._e(),
                          _vm.$vuetify.breakpoint.xsOnly
                            ? _c(
                                "v-list",
                                {
                                  staticStyle: {
                                    "margin-top": "1px",
                                    "overflow-y": "auto",
                                    "border-radius": "0 0 4px 4px",
                                  },
                                  attrs: { "max-height": "180", dense: "" },
                                },
                                _vm._l(
                                  _vm.analyticInstances.filter(
                                    (el) => !el.mergedInstance
                                  ),
                                  function (item, index) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: item.id,
                                        staticClass: "char-lim-more-menu",
                                        on: {
                                          click: function ($event) {
                                            return _vm.addItem(item, index)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            class:
                                              _vm.currentTabItem.id == item.id
                                                ? "primary--text"
                                                : "supplementary-class",
                                            staticStyle: {
                                              "font-size": "15px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.name) + " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                          _vm.$vuetify.breakpoint.xsOnly &&
                          _vm.mergedInstances.length
                            ? _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "pl-4 mt-1 font-weight-bold list-title-background",
                                  staticStyle: {
                                    "border-radius": "4px 4px 0 0",
                                    "font-size": "15px",
                                    "letter-spacing": "0.04rem",
                                  },
                                },
                                [_vm._v("Merged Instances ")]
                              )
                            : _vm._e(),
                          _vm.$vuetify.breakpoint.xsOnly &&
                          _vm.mergedInstances.length
                            ? _c(
                                "v-list",
                                {
                                  staticStyle: {
                                    "margin-top": "1px",
                                    "overflow-y": "auto",
                                  },
                                  attrs: { "max-height": "180", dense: "" },
                                },
                                _vm._l(
                                  _vm.mergedInstances,
                                  function (item, index) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: item.id,
                                        staticClass: "char-lim-more-menu",
                                        on: {
                                          click: function ($event) {
                                            return _vm.addItem(item, index)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "mx-1",
                                            class:
                                              _vm.currentTabItem.id == item.id
                                                ? "primary--text"
                                                : "supplementary-class",
                                            attrs: { justify: "center" },
                                          },
                                          [
                                            item.mergedInstance
                                              ? _c(
                                                  "p",
                                                  { staticClass: "my-auto" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.name) +
                                                        " (" +
                                                        _vm._s(
                                                          item.subinstances
                                                            .length
                                                        ) +
                                                        ") "
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "p",
                                                  { staticClass: "my-auto" },
                                                  [_vm._v(_vm._s(item.name))]
                                                ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }